/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryHasOperand = [string, GamoraUUIDGuard];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryHasResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryHasArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryHasOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryHas extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryHasOperand,
  GamoraFoundationAdapterQueryHasResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.HAS;
  constructor(args: GamoraFoundationAdapterQueryHasArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryHasOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryHas {
    return new GamoraFoundationAdapterQueryHas({
      operand,
      options,
    });
  }
}
